module.exports = __webpack_public_path__ + "static/media/pencil.54adb9ad.svg";